import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-sec002-card-IV',
    templateUrl: './sec002-card-IV.component.html'
})

export class Sec002CardIVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    public dataRecebimento: any;
    
    @Output() mkCalc = new EventEmitter();

    constructor(protected formularioService: FormularioService, 
                protected formBuilder: FormBuilder, 
                protected notificationService: NotificationService, 
                protected generalService: GeneralService) {
        super('Tempos de Ciclo e Atividades', false);
        this.initForm();
    }

    private initForm() {
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Enchimento_horas_atividade_1010: [null, []],
                Primeiro_ciclo_horas: [null, []],
                Segundo_ciclo_horas: [null, []],
                Ressecagem_horas: [null, []],
                Secagem_horas_atividade_2010: [null, []],
                Espera_horas: [null, []],
                Debulha_horas_atividade_3010: [null, []],
            });
        } else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                secagem_horas: [null, []],
                ressecagem_horas: [null, []],
                tempo_de_patio: [null, []]
            });
        }
    }

    public async ngOnInit(): Promise<void> {}

    public changeCollapse(): void {
        this.collapseCard = !this.collapseCard;
    }

    public hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }
}